import { useCallback } from 'react';
import { usePaymentsModalButton, PaymentRequestModal } from '@frontend/payments-collection-flow';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { useNavigate } from '@frontend/weave-router';
import { PAYMENT_ACCOUNT_HELP_LINK } from '../constants';
import { PaymentActionEnum } from '../types';

type UsePaymentActionProps = {
  locationId: string;
};
export const usePaymentAction = ({ locationId }: UsePaymentActionProps) => {
  const { navigate: navigateToSettings } = useSettingsNavigate();
  const navigate = useNavigate();
  const { paymentRequestModalProps, openModal: openInvoiceModal } = usePaymentsModalButton({
    locationIds: [locationId],
  });

  const handleAction = useCallback(
    (action: PaymentActionEnum) => {
      switch (action) {
        case PaymentActionEnum.CREATE_INVOICE:
          openInvoiceModal();
          break;
        case PaymentActionEnum.CREATE_ACCOUNT:
          navigateToSettings({ to: '/payments/account-info' });
          break;
        case PaymentActionEnum.CREATE_ACCOUNT_LEARN_MORE:
          window.open(PAYMENT_ACCOUNT_HELP_LINK, '_blank', 'noopener noreferrer');
          break;
        case PaymentActionEnum.SHARE_INVOICE:
          navigate({ to: '/payments/invoices' });
          break;
        case PaymentActionEnum.ONLINE_BILL_PAY:
          navigateToSettings({ to: '/payments/online-bill-pay' });
          break;
        default:
          break;
      }
    },
    [openInvoiceModal]
  );

  return {
    handleAction,
    InvoiceModal: () => <PaymentRequestModal {...paymentRequestModalProps} />,
  };
};
